module.exports = __webpack_public_path__ + "img/CashFlow.83c91aaf.png";